import {Injectable} from "@angular/core";
import {CustomHttp} from "../../common/http/custom.http";
import {RequestConfig} from "../rest/rest.request";
import {RequestMethod} from "@angular/http";
import {isNullOrUndefined} from "util";
import {Observable} from "rxjs/Observable";
import {Subject} from "rxjs/Subject";

@Injectable()
export class UsersDetailsService {
    public POST_DETAILS = new RequestConfig("USRDETAILS", "application/json", true, RequestMethod.Post, "/users/infoBasicUsers");

    usersDetails: Array<UserDetail> = [];
    private lastTimeChecked: number = null;
    private userDetailsObserver: Subject<any> = new Subject<any>();

    constructor(private http: CustomHttp) {
        // this.loadUsersDetails();
    }

    private loadUsersDetails(lisUser?) {
        this.lastTimeChecked = 0;
        this.http.sendRequest(this.POST_DETAILS, {idUsersList: []})
            .map(res => res.json())
            .subscribe(response => {
                this.usersDetails = response;
                this.lastTimeChecked = new Date().getTime();
                this.userDetailsObserver.next();
            }, error => {
                this.lastTimeChecked = new Date().getTime();
                this.userDetailsObserver.next();
            });
    }

    private getImage(username: string): HTMLElement {
        let imgEl: HTMLElement = $("<div>").addClass("circle-profile");

        let user: UserDetail = this.usersDetails.find(userDetail => userDetail.username == username);
        if (!isNullOrUndefined(user) && !!user.image.contentType && !!user.image.encodedImageContentSmall) {
            let imgBase64: string = "data:" + user.image.contentType + ";base64," + user.image.encodedImageContentSmall;
            $(imgEl).css("background-image", "url(" + imgBase64 + ")");
        } else {
            let iniciales = username.slice(0, 2).toUpperCase();
            let color = this.stringToColour(iniciales);
            $(imgEl).css("background-color", `${color} !important`);
            $(imgEl).text(iniciales);

        }
        return imgEl[0];
    }

    private getImageSmall(username: string): HTMLElement {
        let imgEl: HTMLElement = $("<div>").addClass("circle-profile-small");

        let user: UserDetail = this.usersDetails.find(userDetail => userDetail.username == username);
        if (!isNullOrUndefined(user) && !!user.image.contentType && !!user.image.encodedImageContentSmall) {
            let imgBase64: string = "data:" + user.image.contentType + ";base64," + user.image.encodedImageContentSmall;
            $(imgEl).css("background-image", "url(" + imgBase64 + ")");
        } else {
            let iniciales = username.slice(0, 2).toUpperCase();
            let color = this.stringToColour(iniciales);
            $(imgEl).css("background-color", `${color} !important`);
            $(imgEl).text(iniciales);

        }
        return imgEl[0];
    }

    drawImage(username: string, tam?: string): Observable<HTMLElement> {
        // debugger;
        return Observable.create(observer => {
            if (!!username) {
                if (this.lastTimeChecked < new Date().getTime() - (10 * 60 * 1000/*10 minutes*/)) {
                    if (isNullOrUndefined(this.lastTimeChecked) || this.lastTimeChecked > 0)
                        this.loadUsersDetails();
                    this.userDetailsObserver.asObservable().subscribe(() => {
                        if ( tam === 'small'){observer.next(this.getImageSmall(username)); }else{
                        observer.next(this.getImage(username)); }
                    });
                } else {
                    if ( tam === 'small'){observer.next(this.getImageSmall(username)); }else{
                        observer.next(this.getImage(username)); }
                }
            } else {
                observer.next($("<i>").addClass("menu-icon-user_b").css({fontSize: "2.5em", color: "gray"})[0]);
            }
        });
    }

    drawImageUser(username: string, tam?: string): Observable<HTMLElement> {
        // debugger;
        return Observable.create(observer => {
            if (!!username) {
                if (isNullOrUndefined(this.lastTimeChecked) || this.lastTimeChecked > 0)
                // this.loadUsersDetails();
                    this.userDetailsObserver.asObservable().subscribe(() => {
                        if (tam === 'small') {
                            observer.next(this.getImageSmall(username));
                        } else {
                            observer.next(this.getImage(username));
                        }
                    });
                if (tam === 'small') {
                    observer.next(this.getImageSmall(username));
                } else {
                    observer.next(this.getImage(username));
                }
            } else {
                observer.next($("<i>").addClass("menu-icon-user_b").css({fontSize: "2.5em", color: "gray"})[0]);
            }
        });
    }
    stringToColour(str) {
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
        let color;
        color = Math.floor(Math.abs((Math.sin(hash) * 10000) % 1 * 16777216)).toString(16);
        return '#' + Array(6 - color.length + 1).join('0') + color;
    }
}

export class UserDetail {
    idUser: number;
    image: UserImage;
    name: string;
    username: string;
}

class UserImage {
    contentType: string;
    createdDate: number;
    encodedImageContent: string;
    encodedImageContentSmall: string;
    imageName: string;
    userImageId: number;
}
